RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.Notification = Marionette.ItemView.extend({
        className: 'notification-bar-inner',

        ui: {
            closeBtn: '.x-close',
            contactUsBtn: '.x-contact-us',
            connectTokenBtn: '.x-connect-token'
        },

        events: {
            'click .x-dismiss': 'onDismissClick',
            'click @ui.closeBtn': 'onCloseClick',
            'click @ui.contactUsBtn': 'onContactUsClick',
            'click @ui.connectTokenBtn': 'onConnectClick'
        },

        modelEvents: {
            'change:size': 'onSizeChange'
        },

        behaviors: {
            TrackedLinks: RivalIQ.behaviors.TrackedLinks
        },

        size: App.enums.navigation_size.TALL,

        getTemplate: function () {
            const me = this;
            return me.model.get('templates')[me.model.get('size')];
        },

        formatLabeledNumber: function (n, empty) {
            if (empty && !n) {
                return empty;
            }
            return RivalIQ.formatter.formatLabeledNumber('day', 'days', n);
        },

        templateHelpers: function () {
            const me = this;
            if (me.model.get('id') === RivalIQ.apps.Shell.enums.notifications.EXPIRED_TOKENS) {
                const options = _.omit(me.options, ['model', 'size']);
                return options;
            }

            const days = RivalIQ.state.account.getDaysRemainingInTrial();
            const daysToContractRenewal = RivalIQ.state.account.getDaysUntilContractRenewal();

            const daysToContractRenewalString = me.formatLabeledNumber(daysToContractRenewal, 'today');
            const daysToRenewalStatement = daysToContractRenewalString !== 'today' ? `in ${daysToContractRenewalString}` : daysToContractRenewalString;
            const renewalStatement = daysToContractRenewal >= 0 ? `due for renewal ${daysToRenewalStatement}` : 'overdue';
            const renewalNotificationText = `Your Rival IQ subscription is ${renewalStatement}.`;

            return {
                hasFailedPayment: RivalIQ.state.account.hasFailedPayment(),
                hasPlanOptions: !RivalIQ.state.plan.get('has_quid_compete_branding'),
                canPayOnline: RivalIQ.state.account.canPayOnline(),
                daysRemainingInTrial: me.formatLabeledNumber(days),
                daysToContractRenewal: daysToContractRenewal,
                renewalNotificationText: renewalNotificationText,
                daysLeftString: (days > 1 ? me.formatLabeledNumber(days) : '24 hours')
            };
        },

        onRender: function () {
            const me = this;

            me.$el.parent().toggleClass('token-notification', (me.model.get('id') === RivalIQ.apps.Shell.enums.notifications.EXPIRED_TOKENS));
            me.setSizeOnParent();
        },

        setSizeOnParent: function () {
            const me = this;
            me.$el.parent().removeClass('tall short').addClass(`${me.model.get('size')} in`);
        },

        onDismissClick: function () {
            const me = this;

            const state = RivalIQ.state.user;
            const notifications = state.get('notifications');
            notifications[me.model.id] = {
                dismissed: moment.utc().add(12, 'hours')
            };
            state.set({
                notifications: notifications
            });

            if (me.model.get('id') === RivalIQ.apps.Shell.enums.notifications.EXPIRED_TOKENS) {
                const expiredSources = me.getOption('expiredSources');
                _.each(expiredSources, (source) => {
                    const sourceDetails = RivalIQ.enums.sourceDetails[source];
                    const channel = sourceDetails.channel;

                    RivalIQ.execute('persistence:user:save', function (userSettings) {
                        userSettings[channel + RivalIQ.channels.NAG_EXPIRED_LAST] = new Date();
                    });
                });
            }

            me.destroy();
        },

        onCloseClick: function () {
            const me = this;
            me.size = App.enums.navigation_size.DEFAULT;
            me.model.set('size', me.size);

            me.render();
        },

        onContactUsClick: function () {
            const me = this;

            let description = null;
            if (me.model.id !== RivalIQ.apps.Shell.enums.notifications.PAYMENT_OVERDUE && !RivalIQ.state.account.churned()) {
                description = RivalIQ.state.plan.get('has_quid_compete_branding') ? RivalIQ.strings.notification_contact_description_quid : RivalIQ.strings.notification_contact_description;
            }

            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: me.model.get('id'),
                    modalDescription: description
                })
            }));
        },

        onSizeChange: function () {
            const me = this;

            const notificationSettings = RivalIQ.state.account.get('notifications');
            notificationSettings[me.model.get('id')] = {
                size: me.model.get('size')
            };
            RivalIQ.state.account.set('notifications', notificationSettings);
        },

        initialize: function () {
            const me = this;
            me.listenTo(me, 'render', me.onRender);
            me.listenTo(me, 'attach', me.onRender);

            const notificationType = me.model.get('id');
            const size = _.get(RivalIQ.state.account.get('notifications'), [notificationType, 'size']);

            if (notificationType === App.enums.notifications.TRIAL_EXPIRED && size === App.enums.navigation_size.SHORT) {
                // The SHORT version of trial_expired can be saved in account.settings, we need to show the DEFAULT version instead
                me.model.set('size', App.enums.navigation_size.DEFAULT, {
                    silent: true
                });
            } else {
                me.model.set('size', size || me.getOption('size'), {
                    silent: true
                });
            }
        },

        onDestroy: function () {
            const me = this;
            me.$el.parent().removeClass('in');
        }
    });

}, window.moment);
